import { IIconProps } from "~/types";
const ArchiveIcon = (props:IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 6h10.5M3.75 6a1.5 1.5 0 1 1 0-3h10.5a1.5 1.5 0 0 1 0 3M3.75 6v7.5a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5V6M7.5 9h3"
      stroke="#DE390B"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArchiveIcon;
